import React, { Component } from "react";
import FilterActiveIcon from "./../../../icons/filteractiveicon";
import FilterIcon from "./../../../icons/filtericon";
import service from "../../../../src/services";
import Loader from "../../loader";
import moment from "moment-timezone";
import serachIcon from "./../../../assets/images/search.svg";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../../redux/bindActionCretor";

import ReactPaginate from "react-paginate";
import { debounce } from "lodash";

let sub;

// Filter definitions: idField/nameField describe how each master-data option is keyed/labeled.
const FILTERS = [
  { key: "category", label: "Category", idField: "_id", nameField: "name" },
  { key: "genre", label: "Genre & Type", idField: "_id", nameField: "name", className: "genre_col" },
  { key: "screeningType", label: "Screening Type", idField: "optionKey", nameField: "displayName" },
  { key: "venue", label: "Venue", idField: "_id", nameField: "name", className: "venue_col" },
  { key: "accessibility", label: "Accessibility", idField: "eventiveId", nameField: "name", className: "accessibility_col" },
  { key: "interestTrack", label: "Interest Track", idField: "eventiveId", nameField: "name", className: "interest_track_col" },
];

// Which redux "edit id" action + CurrentTab index a screening's parent record maps to (item.type from fpg|screening|getList).
const RECORD_TYPE_NAV = {
  Film: { currentTab: 0 },
  BeyondFilm: { currentTab: 1 },
  NewFrontier: { currentTab: 2 },
  PartnerEvent: { currentTab: 3 },
  OtherEvent: { currentTab: 4 },
};

let filterLists = {
  category: [],
  genre: [],
  screeningType: [],
  venue: [],
  accessibility: [],
  interestTrack: [],
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};

// merges two master-data arrays (e.g. film.category + beyondFilm.category), de-duped by id
const mergeById = (listA = [], listB = []) => {
  const merged = [...(listA || [])];
  (listB || []).forEach((item) => {
    if (!merged.find((m) => m._id === item._id)) merged.push(item);
  });
  return merged;
};

// fpg|screening|getList rows carry accessibility/interestTrack/locations as raw id arrays;
// resolve them against the matching master-data list for display. Screenings save
// accessibility/interestTrack by eventiveId but locations (venue) by _id (see createFilmTab.js).
const resolveNames = (ids, masterArray, matchField = "_id") =>
  (Array.isArray(ids) ? ids : ids ? [ids] : [])
    .map((id) => (masterArray || []).find((m) => m[matchField] === id))
    .filter(Boolean)
    .map((m) => m.name);

class ScreeningsListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screeningsList: [],
      totalDocs: 0,
      loaderFlag: false,
      searchField: "",
      Screeningoffset: 1,
      perPage: 50,
      ScreeningCurrentPage: 0,
      categoryArray: [],
      genreArray: [],
      screeningTypeArray: [],
      venueArray: [],
      accessibilityArray: [],
      interestTrackArray: [],
    };
    this.apiserve = new service();
    this.debouncedSearch = debounce(() => {
      localStorage.setItem("ScreeningCurrentPage", 0);
      localStorage.setItem("Screeningoffset", 1);
      this.getScreenings(1, this.state.perPage);
    }, 500);
  }

  componentDidMount = () => {
    this.apiserve.sendevent("user|sff|getAllInitial", {});

    let ScreeningCurrentPage = localStorage.getItem("ScreeningCurrentPage");
    if (ScreeningCurrentPage) {
      this.setState(
        {
          Screeningoffset: Math.max(1, parseInt(localStorage.getItem("Screeningoffset")) || 1),
          perPage: parseInt(localStorage.getItem("perPage")) || 50,
          ScreeningCurrentPage: parseInt(localStorage.getItem("ScreeningCurrentPage")) || 0,
        },
        () => this.getScreenings(this.state.Screeningoffset, this.state.perPage)
      );
    } else {
      this.setState(
        {
          Screeningoffset: 1,
          perPage: 50,
          ScreeningCurrentPage: 0,
        },
        () => this.getScreenings(this.state.Screeningoffset, this.state.perPage)
      );
    }

    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "user|sff|getAllInitial":
          const film = response.data && response.data.film;
          const beyondFilm = response.data && response.data.beyondFilm;
          const withValue = (list) => (list || []).map((el) => ({ ...el, value: false }));

          this.setState({
            categoryArray: withValue(mergeById(film && film.category, beyondFilm && beyondFilm.category)),
            // "Genre & Type" filter also lists the Event Types (beyondFilm.eventType)
            genreArray: withValue(mergeById(film && film.genre, beyondFilm && beyondFilm.eventType)),
            // In-person and online types share the same `type`; locationType makes each option unique.
            screeningTypeArray: withValue(film && film.screnningTypeList).map((el) => ({
              ...el,
              optionKey: `${el.type}_${el.locationType}`,
            })),
            venueArray: withValue(film && film.locations),
            accessibilityArray: withValue(mergeById(film && film.accessibility, beyondFilm && beyondFilm.accessibility)),
            interestTrackArray: withValue(mergeById(film && film.interestTrack, beyondFilm && beyondFilm.interestTrack)),
          });
          break;
        case "fpg|screening|getList":
          if (!response.error) {
            // Backend has returned either a bare array or a {docs, totalDocs} page envelope - handle both.
            const raw = response.data;
            const list = Array.isArray(raw) ? raw : (raw && raw.docs) || [];
            const total = Array.isArray(raw) ? list.length : (raw && typeof raw.totalDocs === "number" ? raw.totalDocs : list.length);
            this.setState({
              screeningsList: list,
              totalDocs: total,
              pageCount: Math.ceil(total / this.state.perPage),
              loaderFlag: false,
            });
          } else {
            this.setState({ loaderFlag: false });
            this.apiserve.error(response.data && response.data.error ? response.data.error : response.data);
          }
          break;
        default:
          break;
      }
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
    this.debouncedSearch.cancel();
    filterLists = {
      category: [],
      genre: [],
      screeningType: [],
      venue: [],
      accessibility: [],
      interestTrack: [],
    };
  };

  getScreenings = (skip, limit) => {
    this.setState({ loaderFlag: true });
    var data = {
      page: skip,
      limit: limit,
    };

    if (this.state.searchField.length) data.filter = this.state.searchField;
    if (filterLists.category.length) data.category = filterLists.category;
    if (filterLists.genre.length) data.genre = filterLists.genre;
    if (filterLists.screeningType.length) {
      // filterLists holds unique option keys; the API expects { type, locationType } pairs.
      const selectedKeys = filterLists.screeningType;
      data.screeningType = (this.state.screeningTypeArray || [])
        .filter((t) => selectedKeys.includes(t.optionKey))
        .map((t) => ({ type: t.type, locationType: t.locationType }));
    }
    if (filterLists.venue.length) data.venue = filterLists.venue;
    if (filterLists.accessibility.length) data.accessibility = filterLists.accessibility;
    if (filterLists.interestTrack.length) data.interestTrack = filterLists.interestTrack;

    this.apiserve.sendevent("fpg|screening|getList", data);
  };

  onSearchFilter = (e) => {
    this.setState({ [e.target.name]: e.target.value, ScreeningCurrentPage: 0, Screeningoffset: 1 });
    this.debouncedSearch();
  };

  handleFilterToggle = (filterKey, e, selectedIndex, isClearType = false) => {
    const filterDef = FILTERS.find((f) => f.key === filterKey);
    const arrayKey = `${filterKey}Array`;
    let index = selectedIndex;
    let event = e && e.target && e.target.checked;
    let optionList = [...this.state[arrayKey]];

    optionList.forEach((opt, i) => {
      if (i === index) opt.value = event;
      if (isClearType) opt.value = false;
    });

    if (isClearType) filterLists[filterKey] = [];

    this.setState(
      { [arrayKey]: optionList, ScreeningCurrentPage: 0, Screeningoffset: 1 },
      () => {
        if (!isClearType && index !== null) {
          const optionId = this.state[arrayKey][index][filterDef.idField];
          if (event) {
            filterLists[filterKey] = [...filterLists[filterKey], optionId];
          } else {
            filterLists[filterKey] = filterLists[filterKey].filter((d) => d !== optionId);
          }
        }
        localStorage.setItem("ScreeningCurrentPage", 0);
        localStorage.setItem("Screeningoffset", 1);
        this.getScreenings(1, this.state.perPage);
      }
    );
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const Screeningoffset = selectedPage + 1;

    var tbl = document.querySelector(".film_list_table");
    if (tbl) tbl.scrollTo(0, 0);

    this.setState(
      { ScreeningCurrentPage: selectedPage, Screeningoffset: Screeningoffset, loaderFlag: true },
      () => {
        localStorage.setItem("ScreeningCurrentPage", this.state.ScreeningCurrentPage);
        localStorage.setItem("Screeningoffset", Screeningoffset);
        localStorage.setItem("perPage", this.state.perPage);
        this.getScreenings(Screeningoffset, this.state.perPage);
      }
    );
  };

  editScreening = (item) => {
    const parentId = item.filmId || item._id;
    const type = item.type || "Film";
    const nav = RECORD_TYPE_NAV[type] || RECORD_TYPE_NAV.Film;

    this.props.filmEditData(type === "Film" ? parentId : "");
    this.props.TalkEventEditData(type === "BeyondFilm" ? parentId : "");
    this.props.NewFrontierEditData(type === "NewFrontier" ? parentId : "");
    this.props.PartnerEventsEditData(type === "PartnerEvent" ? parentId : "");
    this.props.OtherEventsEditData(type === "OtherEvent" ? parentId : "");
    this.props.LiveSceeringEditData();
    this.props.CurrentTab(nav.currentTab);

    this.props.history.push({
      pathname: `/film/${parentId}`,
      callFrom: nav.currentTab,
    });
  };

  getVenueLabel = (dateTime) => {
    if (!dateTime) return "";
    if (dateTime.locationType === "2") return "Online";
    return resolveNames(dateTime.locations, this.state.venueArray).join(", ");
  };

  getScreeningTypeLabel = (dateTime) => {
    if (!dateTime || dateTime.screeningType === undefined) return "";
    const list = this.state.screeningTypeArray || [];
    const match =
      list.find((t) => t.type === dateTime.screeningType && t.locationType == dateTime.locationType) ||
      list.find((t) => t.type === dateTime.screeningType);
    return match ? match.displayName || match.name : "";
  };

  getCategoryLabel = (item) => {
    if (!item.category) return "";
    const match = (this.state.categoryArray || []).find((c) => c._id === item.category);
    return match ? match.name : "";
  };

  renderNames = (names) => names.map((name, i) => <p key={i}>{name}</p>);

  renderFilterHeader = (filterDef) => {
    const arrayKey = `${filterDef.key}Array`;
    const options = this.state[arrayKey] || [];
    return (
      <th key={filterDef.key} className={filterDef.className}>
        <span className="disp_flex d_flex_align_center">
          {filterDef.label}
          {filterLists[filterDef.key] && filterLists[filterDef.key].length ? <FilterActiveIcon /> : <FilterIcon />}
        </span>
        <div className="tabelData_popup">
          <form>
            <div className="customCheck">
              <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                <p className="link" onClick={() => this.handleFilterToggle(filterDef.key, null, null, true)}>
                  Clear All
                </p>
              </div>
              <div className="customCheckBox">
                {options.map((item, i) => (
                  <div className="customCheckBox" key={item[filterDef.idField]}>
                    <input
                      type="checkbox"
                      id={filterDef.key + item[filterDef.idField]}
                      name={filterDef.key + item[filterDef.idField]}
                      checked={item.value ? true : false}
                      onChange={(e) => this.handleFilterToggle(filterDef.key, e, i)}
                    />
                    <label htmlFor={filterDef.key + item[filterDef.idField]}>{item[filterDef.nameField]}</label>
                  </div>
                ))}
              </div>
            </div>
          </form>
        </div>
      </th>
    );
  };

  render() {
    const { screeningsList, totalDocs } = this.state;
    return (
      <>
        <div className="table_wrap film_list_table striped_table screening_list_table">
          <table className="tbl_layout_fix">
            <thead>
              <tr>
                <th className="title_search_col">
                  <div className="dashboard_header no_bg p_0">
                    <div className="searchBlock back_date pl_15">
                      <form onSubmit={(e) => e.preventDefault()} className="m_0">
                        <input
                          className="bg_white"
                          type="text"
                          autoComplete="off"
                          placeholder="Search"
                          id="searchField"
                          name="searchField"
                          value={this.state.searchField}
                          onChange={this.onSearchFilter}
                        />
                        <button type="button" style={{ pointerEvents: "none" }}>
                          <img src={serachIcon} />
                        </button>
                      </form>
                    </div>
                  </div>
                </th>
                {this.renderFilterHeader(FILTERS[0])}
                {this.renderFilterHeader(FILTERS[1])}
                <th className="start_end_time_col">Start-End Time (MT)</th>
                {this.renderFilterHeader(FILTERS[2])}
                {this.renderFilterHeader(FILTERS[3])}
                <th>Waitlist Slots</th>
                {this.renderFilterHeader(FILTERS[4])}
                {this.renderFilterHeader(FILTERS[5])}
                <th>Suppress Voting</th>
              </tr>
            </thead>
            <tbody>
              {screeningsList &&
                screeningsList.length > 0 &&
                screeningsList.map((item) => {
                  const dateTime = item.dateTime || {};
                  return (
                    <tr onClick={() => this.editScreening(item)} className="pointer" key={item._id}>
                      <td>
                        <p>{item.title}</p>
                      </td>
                      <td>
                        <p>{this.getCategoryLabel(item)}</p>
                      </td>
                      <td>{this.renderNames(resolveNames([...(item.genre || []), ...(item.eventType ? [item.eventType] : [])], this.state.genreArray, "_id"))}</td>
                      <td className="start_end_time_col">
                        {dateTime.date ? <p>{moment(dateTime.date).tz("US/Mountain").format("MMM DD, YYYY - h:mm A")}</p> : ""}
                        {dateTime.endDate ? <p>{moment(dateTime.endDate).tz("US/Mountain").format("MMM DD, YYYY - h:mm A")}</p> : ""}
                      </td>
                      <td>
                        <p>{this.getScreeningTypeLabel(dateTime)}</p>
                      </td>
                      <td>
                        <p>{this.getVenueLabel(dateTime)}</p>
                      </td>
                      <td>
                        <p>{dateTime.maxWaitListSlots || 0}</p>
                      </td>
                      <td>{this.renderNames(resolveNames(dateTime.accessibility, this.state.accessibilityArray, "eventiveId"))}</td>
                      <td>{this.renderNames(resolveNames(dateTime.interestTrack, this.state.interestTrackArray, "eventiveId"))}</td>
                      <td>
                        <p>{dateTime.supressVoting === undefined ? "-" : dateTime.supressVoting ? "Yes" : "No"}</p>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          {!this.state.loaderFlag && (!screeningsList || !screeningsList.length) && (
            <div className="sd_no_data_found text_center">
              <p>No records found.</p>
            </div>
          )}

          {this.state.loaderFlag ? <Loader /> : ""}
        </div>

        <div className="d_flex d_flex_align_center d_flex_justify_spacebt">
          <div />
          {screeningsList && screeningsList.length ? (
            <div className="custom-pagination">
              <ReactPaginate
                previousLabel={""}
                nextLabel={""}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={this.state.pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                forcePage={this.state.ScreeningCurrentPage}
              />
            </div>
          ) : (
            ""
          )}
          <p style={{ marginLeft: "auto", paddingRight: "15px" }}>Total Screenings: {totalDocs}</p>
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ScreeningsListTable);
